"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateCell = void 0;
var _react = _interopRequireWildcard(require("react"));
var _format = require("../../../../utils/dates/format");
var _headerCellFactory = require("../header-cell/headerCellFactory");
var _loadingCellFactory = require("../loading-cell/loadingCellFactory");
var _calendarNext = require("../../../../assets/icons/calendar-next.svg");
var _dateCellModule = _interopRequireDefault(require("./date-cell.module.scss"));
var _Tooltip = require("../../../tooltip/Tooltip");
var _useTranslation2 = require("../../../../hooks/useTranslation/useTranslation");
var _classnames = _interopRequireDefault(require("classnames"));
var DateCell = function DateCell(_ref) {
  var date = _ref.data,
    className = _ref.className;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var isFutureDate = (0, _react.useMemo)(function () {
    return date && date.getTime() > Date.now();
  }, [date]);
  return /*#__PURE__*/_react.default.createElement("td", {
    className: (0, _classnames.default)(_dateCellModule.default['date-cell'], className)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _dateCellModule.default['date-cell__date']
  }, date ? (0, _format.formatFullDate)(date) : '-'), isFutureDate && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    position: "bottom",
    variant: "light",
    className: _dateCellModule.default['date-cell__tooltip'],
    containerClassName: _dateCellModule.default['date-cell__icon-container'],
    title: t('dateCell.futurePayment')
  }, /*#__PURE__*/_react.default.createElement(_calendarNext.ReactComponent, {
    className: _dateCellModule.default['date-cell__future-icon'],
    "data-testid": "future-date-icon"
  })));
};
exports.DateCell = DateCell;
DateCell.Header = (0, _headerCellFactory.headerCellFactory)(_dateCellModule.default['date-cell']);
DateCell.Loading = (0, _loadingCellFactory.loadingCellFactory)(_dateCellModule.default['date-cell']);